import { MOVE_TO_NEXT_STEP, MOVE_TO_PREVIOUS_STEP } from 'redux/actions/types';
import { takeLatest } from 'redux-saga/effects';
import { moveToNextStep, moveToPreviousStep } from './step-saga';

export default function* routeSagas() {
  yield takeLatest(MOVE_TO_NEXT_STEP, moveToNextStep);
  yield takeLatest(MOVE_TO_PREVIOUS_STEP, moveToPreviousStep);
}
